import React, { useCallback, useEffect, useState } from 'react'


import styles from '../../css/style.module.css'
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaPlus } from "react-icons/fa6";

import { VscSettings } from "react-icons/vsc";

import HOC from '../../components/HOC/HOC'
import { useNavigate } from 'react-router-dom';
import { DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import FilterModal from '../../components/Modals/FilterModal';
import endPoints from '../../Repository/apiConfig';
import { deleteApi, getApi } from '../../Repository/Api';
import img2 from '../../assest/loading1.gif'

import { formatDateTime } from '../../utils/utils'


const columns = [
  'S.no',
  'Offer Name',
  'Offer Image',
  'Code',
  'Discount',
  'Start Date',
  'End Date',
  'Description',
  'Creation Date',
  'Status',
  'Action'
];








const VoucherOffers = () => {
  const navigate = useNavigate()
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [coupondata, setCouponData] = useState([])
  const [loading, setLoading] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [selecteddata, setSelectedData] = useState(null);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const fetchData =useCallback(async () => {
    await getApi(endPoints.getallcoupon(selectedFilter), {
      setResponse: setCouponData,
      setLoading,
      errorMsg: 'Failed to fetch voucher & offer!'
    });
  }, [selectedFilter]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);




  const handleDelete = async () => {
    if (!selecteddata) return;

    await deleteApi(endPoints.deletecoupon(selecteddata), {
      setLoading,
      // successMsg: 'Category deleted successfully!',
      errorMsg: 'Failed to delete voucher & offer!'
    });

    fetchData();
    setShowDeleteModal(false);
    setShowSuccessModal(true);
    setTimeout(() => setShowSuccessModal(false), 2000);
  };
  const openDeleteModal = (categoryId) => {
    setSelectedData(categoryId);
    setShowDeleteModal(true); // Open confirm delete modal
  };

  const filterOptions = [
    { label: "Active", value: "active" },
    { label: "Expired", value: "inactive" },
  ];

  const handleApply = (appliedFilter) => {
    setSelectedFilter(appliedFilter);
    setShowDropdown(false);
  };
  return (
    <>
      <DeleteSuccessfullyModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={handleDelete}
        text="delete voucher & offer"
      />
      <SuccessfullyModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        text="Successfully Deleted"
      />
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>Vouchers & Offers</h6>
          </div>
          <div className={styles.rightbuttons}>
            <div className={styles.rightbuttons2} onClick={() => navigate('/voucher-Offers/add')}>
              <FaPlus color='#FFFFFF' />
              <p>Create  Vouchers & Offers</p>
            </div>
            <div className={styles.filterbutton} onClick={toggleDropdown}>
              <VscSettings color='#737373' size={20} />
              <p>Filters</p>
            </div>
            {showDropdown && (
              <FilterModal
                handleApply={handleApply}
                filterOptions={filterOptions}
                selectedFilter={selectedFilter}
              />
            )}

          </div>
        </div>
        <div className={styles.jobchildcontainer}>
          <div className={styles.tablecontainer}>
            <table className={styles.table1}>
              <thead>
                <tr>
                  {columns.map((label, index) => (
                    <th key={index} className={styles.tableHeader}>{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ?
                  <tr>
                    <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                      <img src={img2} alt="" width={100} height={100} />
                    </td>
                  </tr>
                  :
                  coupondata?.data?.length === 0 ?
                    <tr>
                      <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                        No data available.
                      </td>
                    </tr>
                    :
                    coupondata?.data?.map((itme, rowIndex) => (
                      <tr key={rowIndex} className={styles.tableRow}>
                        <td className={styles.tableCell}>{rowIndex + 1}</td>
                        <td className={styles.tableCell}>
                          {itme.title}
                        </td>
                        <td><img src={itme?.image} alt={itme?.name} className={styles.imgtable} /></td>
                        <td className={styles.tableCell}>
                          {itme.code}
                        </td>
                        <td className={styles.tableCell}>
                          {itme.discount}{itme.per === "Percentage" ? "%" : "Rs"}
                        </td>
                        <td className={styles.tableCell}>
                          {formatDateTime(itme.activationDate)}
                        </td>
                        <td className={styles.tableCell}>
                          {formatDateTime(itme.expirationDate)}
                        </td>
                        <td className={styles.tableCell}>
                          {itme.description}
                        </td>
                        <td className={styles.tableCell}>
                          {formatDateTime(itme.createdAt)}
                        </td>
                        <td className={styles.tableCell}
                          style={{
                            color:
                              itme.isExpired ? '#FF0E0E' :
                                '#00AD1D',
                            fontWeight: '600'
                          }}>
                          {itme.isExpired ? "Expired" : "Active"}
                        </td>
                        <td>
                          <div className={styles.tableaction}>
                            {/* <FaRegEdit size={20} onClick={() => navigate('/voucher-Offers/edit')} /> */}
                            <RiDeleteBin6Line size={20}
                              onClick={() => openDeleteModal(itme._id)}
                              style={{ cursor: "pointer", color: "#d9534f" }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))
                }
              </tbody>
            </table>
          </div>
        </div>

      </div >
    </>
  )
}

export default HOC(VoucherOffers)
